import clsx from 'clsx';
import type { ReactNode } from 'react';

interface CardProps {
  className?: string;
  children: ReactNode;
  /** Lifts the card slightly on hover. For cards that are themselves links. */
  interactive?: boolean;
}

export function Card({ className, children, interactive = false }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-line bg-card shadow-sm',
        interactive &&
          'transition-[transform,box-shadow,border-color] duration-200 ' +
            'ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-0.5 ' +
            'hover:border-line-strong hover:shadow-md',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, description, action, icon }: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 border-b border-line px-5 py-4">
      <div className="flex items-start gap-3">
        {icon !== undefined && (
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-soft text-accent-soft-fg">
            {icon}
          </span>
        )}
        <div>
          <h2 className="text-sm font-semibold text-ink">{title}</h2>
          {description !== undefined && <p className="mt-0.5 text-sm text-muted">{description}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}
